import { render, staticRenderFns } from "./DraggableWrapper.vue?vue&type=template&id=4e446e21&scoped=true&"
import script from "./DraggableWrapper.vue?vue&type=script&lang=js&"
export * from "./DraggableWrapper.vue?vue&type=script&lang=js&"
import style0 from "./DraggableWrapper.vue?vue&type=style&index=0&id=4e446e21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e446e21",
  null
  
)

export default component.exports